interface TokenService {
  setToken(token: string): void;
  getToken(): string | null;
  clearToken(): void;
}

const TOKEN_KEY = 'okta-token';

export const tokenService: TokenService = {
  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }
}; 